import React, { Component } from 'react'
import Select from 'react-select';
import { BACKEND_URL } from '../../../config/constants';
import AuxRoutines from '../../../AuxRoutines';
import LogoCliente from '../../HeaderLogos';

class InsightcareHeaderPS extends Component {
  render() {
    const { title, dataDorToracica, dataAVCDerrame, dataPacientes = [], tipoSelecionado, pacienteSelecionado, selecionarPaciente, onVoltar, urlProbabilidadeInternacao, base, company, mostrarLocais, alternarLocais } = (this.props);

    const siglaLocal = AuxRoutines.getLocationInitials(base, company, BACKEND_URL);
    const tituloComLocal = siglaLocal ? `${title} - ${siglaLocal}` : title;
    const locaisMV = AuxRoutines.getLocaisPainelPS();

    const seletorLocais = (
      <div className={'dropdown navegacaoUnidadesWrapper' + (mostrarLocais ? ' open' : '')}>
          <button
            type='button'
            className='btnNavegacaoUnidades'
            onClick={alternarLocais}
            title='Unidade Hospitalar'
          >
            <img src="/img/hospital.svg" alt="" />
            <img className='btnNavegacaoUnidadesSeta' src="/img/chevron-down.svg" alt="" />
          </button>
          {mostrarLocais && (
            <div className="navegacaoUnidadesOverlay" onClick={alternarLocais} />
          )}
          <div className='dropdown-menu navegacaoUnidadesDropdown'>
            <div className="navegacaoUnidadesTitle">Unidade Hospitalar</div>
            {locaisMV.map((local) => {
              const localAtual = local.base === base && Number(company) === local.company;

              return localAtual ? (
                <div key={`${local.base}-${local.company}`} className='navegacaoUnidadesOption ativo' title={local.sigla}>
                  {local.nome}
                </div>
              ) : (
                <a
                  key={`${local.base}-${local.company}`}
                  className='navegacaoUnidadesOption'
                  href={`/painel/ps-monitoramento/${local.base}/${local.company}`}
                  title={local.sigla}
                >
                  {local.nome}
                </a>
              );
            })}
          </div>
      </div>
    );

    const botaoProbabilidadeInternacao = urlProbabilidadeInternacao && (
      <>
        <span className='headerPS-divisor'></span>
        <a
          className='btn-probabilidade-internacao'
          href={urlProbabilidadeInternacao}
          target='_blank'
          rel='noopener noreferrer'
          title='Probabilidade de Internação'
        >
          <img src="/img/chart-no-axes-column.svg" alt="Probabilidade de Internação" />
        </a>
      </>
    );

    if (tipoSelecionado === null) {
      let spanAlerta = '';

      if (dataDorToracica !== null && dataAVCDerrame !== null) {
        spanAlerta = (
          <>
            <span><img src="/img/icon-triangle-exclamation-regular.svg" alt="" />Atenção!</span>
            <span>Dor torácica: {dataDorToracica}</span>
            <span>AVC/Derrame: {dataAVCDerrame}</span>
          </>
        );
      } else if (dataDorToracica !== null) {
        spanAlerta = (
          <>
            <span><img src="/img/icon-triangle-exclamation-regular.svg" alt="" />Atenção! Paciente com dor torácica:</span>
            <span>{dataDorToracica}</span>
          </>
        );
      } else if (dataAVCDerrame !== null) {
        spanAlerta = (
          <>
            <span><img src="/img/icon-triangle-exclamation-regular.svg" alt="" />Atenção! Paciente com AVC/Derrame:</span>
            <span>{dataAVCDerrame}</span>
          </>
        );
      }

      return (
        <div className='headerPS'>
          <div className='headerPS-title'>
            {seletorLocais}
            {tituloComLocal}
          </div>
          {(dataDorToracica !== null || dataAVCDerrame !== null) && (
            <div className='headerPS-paciente'>
              {spanAlerta}
            </div>
          )}
          <div className='headerPS-logo'>
            <img src="/img/insightcare_lamp.svg" alt="InsightCare" />
            <img src={"/img/powered_insightcare.svg"} alt="Insightcare" style={{ height: '2.5vh', marginLeft: '10px' }} />
            <span className='headerPS-divisor'></span>
            <LogoCliente backendUrl={BACKEND_URL} />
            {botaoProbabilidadeInternacao}
          </div>
        </div>
      )
    } else {
      return (
        <div className='headerPS'>
          <div className='headerPS-title'>
            <img src="/img/icon_arrow_left_2.svg" alt="InsightCare" onClick={onVoltar} />
            {title}
          </div>
          <div className='headerPS-search'>
            <div className='buttonSearch'>
              <img src="/img/icon_search.svg" alt="" />
              <Select
                className='selectSearch'
                placeholder="Busque por um paciente..."
                options={
                  dataPacientes.map(opt => ({
                    key: opt.CODIGOPACIENTE,
                    label: `${opt.NOMEPACIENTE} (${opt.CODIGOATENDIMENTO})`,
                    value: opt.CODIGOPACIENTE,
                  }))}
                value={
                  dataPacientes
                    .map(opt => ({
                      key: opt.CODIGOPACIENTE,
                      label: `${opt.NOMEPACIENTE} (${opt.CODIGOATENDIMENTO})`,
                      value: opt.CODIGOPACIENTE,
                    }))
                    .find(o => o.value === pacienteSelecionado) || null
                }
                isClearable={true}
                onChange={opt => {
                  if (opt) {
                    selecionarPaciente(opt.value);
                  } else {
                    selecionarPaciente(null);
                  }
                }}
              />
            </div>
          </div>
          <div className='headerPS-logo'>
            <img src="/img/insightcare_lamp.svg" alt="InsightCare" />
            <img src={"/img/powered_insightcare.svg"} alt="Insightcare" style={{ height: '2.5vh', marginLeft: '10px' }} />
            <span className='headerPS-divisor'></span>
            <LogoCliente backendUrl={BACKEND_URL} />
            {botaoProbabilidadeInternacao}
          </div>
        </div>
      )
    }
  }
}

export default InsightcareHeaderPS;
